"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

require("element-closest");

var _getTextFromNode = require("../../helpers/getTextFromNode");

var _getTextFromNode2 = _interopRequireDefault(_getTextFromNode);

var _tokens = require("../../helpers/tokens.json");

var _tokens2 = _interopRequireDefault(_tokens);

var _tokenHelpers = require("../../helpers/tokenHelpers");

var _RawButton = require("../../RawButton");

var _RawButton2 = _interopRequireDefault(_RawButton);

require("./CheckableList.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckableList = function (_Component) {
  _inherits(CheckableList, _Component);

  function CheckableList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CheckableList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckableList.__proto__ || Object.getPrototypeOf(CheckableList)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelection = function (event) {
      event.stopPropagation();
      var $input = void 0;
      if (event.target.tagName === "INPUT") {
        $input = event.target;
      } else {
        event.preventDefault();
        $input = event.target.closest(".checkable-item").getElementsByTagName("input")[0];
        $input.checked = !$input.checked;
      }
      var id = $input.getAttribute("data-id");
      var action = $input.checked ? "add" : "remove";

      _this.props.handleSelection({ action: action, itemId: id });
    }, _this.handleSingleSelection = function (itemId) {
      return function () {
        _this.props.handleSelection({ itemId: itemId });
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CheckableList, [{
    key: "renderSingleSelectOption",
    value: function renderSingleSelectOption(item) {
      var ariaLabel = (0, _getTextFromNode2.default)(item);

      return _react2.default.createElement(
        _RawButton2.default,
        {
          ariaLabel: ariaLabel,
          className: "checkable-item__button",
          isDisabled: item.props.isDisabled || this.props.isDisabled,
          onClick: this.handleSingleSelection(item.props.id)
        },
        _react2.default.createElement(
          "div",
          { "aria-checked": item.props.isSelected, className: "checkable-item__row", role: "checkbox" },
          _react2.default.createElement(
            "span",
            { className: "checkable-item__label", title: ariaLabel },
            item
          )
        )
      );
    }
  }, {
    key: "renderMultiSelectOption",
    value: function renderMultiSelectOption(item) {
      var ariaLabel = (0, _getTextFromNode2.default)(item);

      return _react2.default.createElement(
        _RawButton2.default,
        {
          ariaLabel: ariaLabel,
          className: "checkable-item__button",
          isDisabled: item.props.isDisabled || this.props.isDisabled,
          onClick: this.handleSelection
        },
        _react2.default.createElement(
          "span",
          { className: "checkable-item__row" },
          _react2.default.createElement(
            "span",
            { className: "checkable-item__checkbox" },
            _react2.default.createElement("input", {
              "aria-label": "Toggle Selection" // TODO: i18n
              , checked: item.props.isSelected,
              disabled: item.props.isDisabled || this.props.isDisabled,
              "data-id": item.props.id,
              id: item.id,
              onChange: function onChange() {},
              onClick: this.handleSelection,
              tabIndex: "-1",
              type: "checkbox"
            })
          ),
          _react2.default.createElement(
            "span",
            { className: "checkable-item__content" },
            _react2.default.createElement(
              "label",
              { htmlFor: item.id, className: "checkable-item__label", title: ariaLabel },
              item
            )
          )
        )
      );
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this2 = this;

      var _props = this.props,
          list = _props.list,
          isMultiselectable = _props.isMultiselectable;

      return list.map(function (item) {
        var style = void 0;

        var _item$props = item.props,
            depth = _item$props.depth,
            remainingProps = _objectWithoutProperties(_item$props, ["depth"]);

        var newItem = _react2.default.cloneElement(item, remainingProps, item.props.children);
        var className = (0, _classnames2.default)("checkable-item", {
          "checkable-item--checked": newItem.props.isSelected,
          "checkable-item--on-tree": depth,
          "checkable-item--is-disabled": newItem.props.isDisabled
        });

        if (depth) style = { marginLeft: depth * (0, _tokenHelpers.toInt)(_tokens2.default.space) * 4 + "px" };

        return _react2.default.createElement(
          "div",
          { key: newItem.props.id, className: className, role: "listitem", style: style },
          isMultiselectable ? _this2.renderMultiSelectOption(newItem) : _this2.renderSingleSelectOption(newItem)
        );
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "aclui-multiselect__checkable-list", role: "list" },
        this.renderList()
      );
    }
  }]);

  return CheckableList;
}(_react.Component);

CheckableList.propTypes = {
  handleSelection: _propTypes2.default.func.isRequired,
  isDisabled: _propTypes2.default.bool,
  isMultiselectable: _propTypes2.default.bool,
  list: _propTypes2.default.arrayOf(_propTypes2.default.node)
};

CheckableList.defaultProps = {
  isDisabled: false,
  isMultiselectable: true,
  list: []
};

exports.default = CheckableList;